import { render, staticRenderFns } from "./expand-collapse.vue?vue&type=template&id=ec815846&scoped=true"
import script from "./expand-collapse.vue?vue&type=script&lang=js"
export * from "./expand-collapse.vue?vue&type=script&lang=js"
import style0 from "./expand-collapse.vue?vue&type=style&index=0&id=ec815846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec815846",
  null
  
)

export default component.exports